module.exports = __webpack_public_path__ + "static/media/YF09_2.a3a6f27e.jpg";